module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/file-icons/zipped.svg?7840a7c409e912e4960f1c9db5a98b0d";